/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { createApp } from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const v_app = createApp({});
const files = require.context('./components', true, /\.vue$/i)
files.keys().forEach(fileName => {
    const componentConfig = files(fileName);
    const componentName   = fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '');

    v_app.component(
        componentName,
        componentConfig.default || componentConfig
    );
});
v_app.mount('#v-app');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// 共通処理
import './common/initialize'
import './common/filter'
import './common/requestTooLargeChecker'
import './common/label'
import './common/modal'
import './common/timeTable'
import './common/floatFormMenu'
import './common/reportEdit'
import './common/reportCostEdit'
import './common/reportDeliverablesEdit'
import './common/ownManagementEdit'
import './common/g-notification'
import './common/user-delete'
import './common/notificationUsers'
import './common/oneClickButton'
import './common/invitation-block'
import './common/invoiceCostEdit'
import './common/role'
import './common/proxyLogin'
import './common/price'
import './common/ccUsers'
import './common/contentTable'

// 個別ページ処理
import './pages/admin/client/invoice/submission'
import './pages/admin/client-users/index'
import './pages/admin/agent-users/index'
import './pages/admin/partner-users/show'
import './pages/admin/demo/clients/index'
import './pages/admin/news/index'
import './pages/admin/supports/index'
import './pages/agent/company/index'
import './pages/agent/company/user/index'
import './pages/agent/company/users/index'
import './pages/agent/company/receipt/index'
import './pages/agent/contract/new/index'
import './pages/agent/contract/edit/index'
import './pages/agent/contract/edit/setting'
import './pages/agent/contract/edit/billing'
import './pages/agent/contract/detail/index'
import './pages/agent/contract/list/index'
import './pages/agent/index'
import './pages/agent/setting/index'
import './pages/agent/report/index'
import './pages/agent/invoice/index'
import './pages/agent/invoice/sf-contract'
import './pages/agent/regist/index'
import './pages/agent/payment/show'
import './pages/agent/unregistered_users/index'
import './pages/client/company/user/index'
import './pages/client/company/users/index'
import './pages/client/company/receipt/index'
import './pages/client/company/freee/index'
import './pages/client/company/freee/approval_flow_route'
import './pages/client/company/freee/setting'
import './pages/client/company/biller/edit'
import './pages/client/setting/index'
import './pages/client/contract/new/index'
import './pages/client/contract/detail/index'
import './pages/client/contract/list/index'
import './pages/client/report/index'
import './pages/client/invoice/index'
import './pages/client/invoice/freee/index'
import './pages/client/invoice/list/index'
import './pages/client/partners/index'
import './pages/client/tutorial'
import './pages/partner/report/index'
// import './pages/partner/contract/list/index'
import './pages/partner/contract/edit'
import './pages/partner/invoice/index'
import './pages/partner/invoice/edit'
import './pages/partner/setting/index'
import './pages/partner/regist/index'
import './pages/partner/tutorial'
import './pages/entry/create'

// 最終処理(このimportより後に追加しないこと)
import './common/post-initialize'
